// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_3wN26","button":"index_button_3z0vQ"};